module.exports = __webpack_public_path__ + "img/w9-b1.5d260747.jpg";